import { render, staticRenderFns } from "./credit_repayment_log_dialog.vue?vue&type=template&id=48db559d&scoped=true"
import script from "./credit_repayment_log_dialog.vue?vue&type=script&lang=js"
export * from "./credit_repayment_log_dialog.vue?vue&type=script&lang=js"
import style0 from "./credit_repayment_log_dialog.vue?vue&type=style&index=0&id=48db559d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db559d",
  null
  
)

export default component.exports